import { k8sRequest, makeK8sCreator } from "../../api";

/** Tail sizes offered in the UI. Small by default - most answers are at the end. */
export const TAIL_SIZES = [100, 500, 1000];
export const DEFAULT_TAIL = 100;

export interface LogQuery {
    namespace: string;
    pod: string;
    container?: string;
    tailLines?: number;
    timestamps?: boolean;
    /** Logs from the previous instance. Only valid when the container has restarted. */
    previous?: boolean;
}

/** Build the query string Kubernetes expects for a log request. */
export const logQueryParameters = (query: LogQuery): { [key: string]: string } => {
    const parameters: { [key: string]: string } = {
        tailLines: `${query.tailLines || DEFAULT_TAIL}`,
        timestamps: query.timestamps ? "true" : "false",
    };

    if (query.container) {
        parameters.container = query.container;
    }
    if (query.previous) {
        parameters.previous = "true";
    }

    return parameters;
};

export const logPath = (query: LogQuery): string =>
    `api/v1/namespaces/${encodeURIComponent(query.namespace)}/pods/${encodeURIComponent(query.pod)}/log`;

/**
 * Pod logs come back as text/plain, not JSON, so there is no parse function:
 * the reducer keeps the raw response in its `text` field and the container
 * reads that directly.
 */
const logs = makeK8sCreator<unknown>("k8sPodLogs", (body) => body);

const getLogsAction = (query: LogQuery) => logs.createThunk(k8sRequest(logPath(query), logQueryParameters(query)));

export { getLogsAction };
export const reducer = logs.reducer;
